import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[portalAccordion]'
})
export class AccordionDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
